<template>
  <div id="app">
    <h1 class="main-title" v-if="$route.path === '/'">Li Zifei's Home</h1>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route(to) {
      // 移除未使用的 from 参数
      console.log('路由变化:', to.path);
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f5f6fa;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.main-title {
  font-size: 2.8rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  padding: 2rem 1rem;
  position: relative;
  display: inline-block;
  background-color: transparent;
}

.main-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 4px;
  background: linear-gradient(to right, #3498db, #2ecc71);
  border-radius: 2px;
}

/* 添加响应式设计 */
@media (max-width: 768px) {
  .main-title {
    font-size: 2rem;
    padding: 1.5rem 1rem;
  }
}
</style>
